<div class="flex-row">

  <div class="flex-col">
    <div class="flex-1 document-title">
      {{ documentType() }}
      @if (this.isRequired()) {
        <span class="required-field">*</span>
      }
    </div>
    @if (documentType() === 'Certificate of Conformance' && order().isReworkRequired()) {
      <h5 class="document-title" style="color: red">This document must contain a rework statement.</h5>
    }
  </div>

  @if (order().status) {
    <div class="flex-1 file-upload-section" >
      <div class="document-message">
        <div class="document-upload-button-section">
          <button class="document-upload-button">Click Here To Upload Documents</button>
          <input type="file" ng2FileSelect [uploader]="uploader" (onFileSelected)="uploadFiles($event)" />
        </div>
      </div>
    </div>
  }
</div>

<div class="document-divider"><hr></div>

@if (order().documents.get(documentType()) && order().documents.get(documentType()).length > 0) {
  <div>
    @for (document of order().documents.get(documentType()); track document; let i = $index) {
      <div class="file-upload-section">
        <div class="document-remove-zone">
          <div class="flex-row">
            <div class="flex-2 document-file-info">
              {{ document.name }}
              &nbsp;
              Uploaded: {{document.dateUploaded ? document.dateUploaded.toLocaleDateString() : null}} <!-- TODO Checking if not null will not be needed in future -->
            </div>
            <div class="flex-1">
              @if (order().status) {
                <button class="document-remove-button" (click)="documentRemove(i)">Remove</button>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}

